__turbopack_context__.v({
  "chartColumn": "RedListIndexFrame-module__zfU5zW__chartColumn",
  "chartPlate": "RedListIndexFrame-module__zfU5zW__chartPlate",
  "chromeScope": "RedListIndexFrame-module__zfU5zW__chromeScope",
  "filterColumn": "RedListIndexFrame-module__zfU5zW__filterColumn",
  "layout": "RedListIndexFrame-module__zfU5zW__layout",
  "root": "RedListIndexFrame-module__zfU5zW__root",
  "statsColumn": "RedListIndexFrame-module__zfU5zW__statsColumn",
});
